export default __webpack_public_path__ + "static/media/sg_veran.5712bda3.bmp";